'use strict';
(function defButtonsCollection(global) {

  /**
  * Часто используемые селекторы
  */
  const buttonSelector = '.toolbar_button';
  const byNameSelectorTemplate = '{0}[name={1}]';
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Класс-обертка для коллекции кнопок
  * @class WebAccess.components.wrappers.toolBar.Buttons
  * @extends WebAccess.Collecton
  * @since 5.2.0.1600
  */
  var Buttons = global.Collection.extend({

    // Список действий и соответствующих им кнопок на ленте.
    _buttonsByActionName: {},

    // Список режимов доступности и соответствующих им действий.
    _buttonsByEnabledMode: {},

    // Список кнопок, состояние которых изменяется в зависимости от выделения вложений
    _buttonsEnabledOnAttachmentSelection: [],

    // Список кнопок, доступных при наличии выделенных записей
    _buttonsEnabledForMultiSelected: {},

    // Список кнопок, доступных только при выделенной 1 записи
    _buttonsEnabledOnlyForOneSelected: {},

    /**
     * Конструктор.
     *
     * @param {array} elements Список кнопок.
     */
    init(elements) {
      var me = this;
      me._super(elements);

      // Сформировать списки
      me._arr.forEach(function (item) {
        // Действия и соответствующие им кнопки
        var linkedAction = item.getLinkedAction();
        var buttons = null;
        if (linkedAction) {
          buttons = me._buttonsByActionName[linkedAction];
          if (buttons) {
            buttons.push(item);
          } else {
            me._buttonsByActionName[linkedAction] = [item];
          }
        }

        // Режимы доступности и соответствующие им кнопки
        var enabledMode = item.getEnabledMode();
        if (enabledMode) {
          buttons = me._buttonsByEnabledMode[enabledMode];
          if (buttons) {
            buttons.push(item);
          } else {
            me._buttonsByEnabledMode[enabledMode] = [item];
          }
        }

        // Сформировать список кнопок, состояния которых изменяются в зависимости от выделения элементов
        if (item.getIsEnabledOnAttachnentSelected()) {
          me._buttonsEnabledOnAttachmentSelection.push(item);
        }

        // Сформировать список кнопок, состояния которых изменяются в зависимости от выделения элементов
        if (item.getIsEnabledOnlyForSelected() && item.groupName === "TOOLBAR_CONTENTS_ACTIONS_GROUP") {
          if (item.getIsEnabledWhenMultiSelect()) {
            me._buttonsEnabledForMultiSelected[item.name] = item;
          } else {
            me._buttonsEnabledOnlyForOneSelected[item.name] = item;
          }
        }
      });

      me._jToolBarConatainer = $('#toolbar_container');
      me._jSearchTarget = me._jToolBarConatainer.find(buttonSelector);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создать новую кнопку панели инструментов.
    *
    * @method WebAccess.components.wrappers.toolBar.Buttons#create
    * @param {string} toolGroupName Имя группы кнопок, в которую будет вложена кнопка.
    * @param {string | object} buttonName Имя создаваемой кнопки или объект {name: "", text:"", action:"", icon:""}
    * @param {boolean} [isSmall = false] Является ли кнопка только иконкой (без названия).
    * @throws ERR_SPECIFIED_BUTTONS_GROUP_DOES_NOT_EXIST – указанной группы кнопок не существует;
    * @throws ERR_BUTTON_NAME_IS_NOT_SPECIFIED – неверно указано имя кнопки;
    * @throws ERR_BUTTON_WITH_THE_SAME_NAME_ALREADY_EXIST – кнопка с указанным именем уже существует.
    * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    */
    create(toolGroupName, buttonName, isSmall = false) {
      if (arguments.length < 2) {
        global.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED');
      }

      const name = buttonName.name || buttonName;
      if (!name) {
        global.raise('ERR_BUTTON_NAME_IS_NOT_SPECIFIED_PROPERLY');
      }

      const text = buttonName.text || L('NEW_BUTTON');
      // Обработчик клика передаётся либо в свойстве action в виде строки, либо в jsaction в виде фукции
      const action = buttonName.action || (buttonName.jsaction ? '' : `alert(L('WRN_USE_CLICK_OR_BIND_METHODS_TO_SET_THE_ACTION'));`);
      const icon = buttonName.icon || 'document-20';
      const toolTip = buttonName.toolTip || text;
      const contentsActionEnabledMode = buttonName.contentsActionEnabledMode;

      const groupSelector = '.toolbar_group';
      const currentGroupSelector = format(byNameSelectorTemplate, groupSelector, toolGroupName);
      let jToolGroup = this._jToolBarConatainer.find(currentGroupSelector);
      if (!jToolGroup.length) {
        global.raise('ERR_SPECIFIED_BUTTONS_GROUP_DOES_NOT_EXIST', toolGroupName);
      }

      const currentButtonSelector = format(byNameSelectorTemplate, buttonSelector, name);
      const jExistingButton = this._jToolBarConatainer.find(currentButtonSelector);
      if (jExistingButton.length > 0) {
        global.raise('ERR_BUTTON_WITH_THE_SAME_NAME_ALREADY_EXIST', name);
      }

      if (global.current.toolBar.groups[toolGroupName].isCollapsed()) {
        jToolGroup = jToolGroup.find('.addedHiddenDiv');
      }

      const buttonClass = `${isSmall ? 'small_' : ''}toolbar_item toolbar_button`;

      // Разные шаблоны для кнопки с svg-иконкой и, ради совместимости, для кнопки с png-иконкой. Начиная с v5.5
      let buttonTemplate = icon.endsWith('.png') ? CT.toolBar.button : CT.toolBar.buttonSvg;
      jToolGroup.append(format(buttonTemplate.replace(/> +</g, '><'), name, text, action, icon, buttonClass, toolTip));

      let button = new global.components.wrappers.toolBar.ToolBarButton(currentButtonSelector);
      button.isSynthetic = true;
      this.addElement(name, button);

      jExistingButton.hover(
        () => {
          $(this).addClass('hover');
        },
        () => {
          $(this).removeClass('hover');
        }
      );

      // jsaction  не зависит от action, передаётся только как функция и используется только через bind
      if (buttonName.jsaction) {
        this[name].bind('click', buttonName.jsaction);
      }

      // Сформировать список кнопок, состояния которых изменяются в зависимости от выделения элементов
      if ((contentsActionEnabledMode & CONTENTS_ACTION_ENABLED_MODE.ENABLED_ONLY_FOR_SELECTED) && toolGroupName === 'TOOLBAR_CONTENTS_ACTIONS_GROUP') {
        if (contentsActionEnabledMode & CONTENTS_ACTION_ENABLED_MODE.ENABLED_WHEN_MULTISELECT) {
          this._buttonsEnabledForMultiSelected[name] = button;
        } else {
          this._buttonsEnabledOnlyForOneSelected[name] = button;
        }
      }

      return this[name];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удалить кнопку панели инструментов.
    *
    * @method WebAccess.components.wrappers.toolBar.Buttons#remove
    * @param {string} buttonName Имя создаваемой кнопки панели инструментов
    * @return {WebAccess.current.toolBar.buttons} Пространство имен WebAccess.components.wrappers.toolBar.Buttons#
    */
    remove(buttonName) {
      var me = this;
      delete me[buttonName];
      me._jToolBarConatainer.find(format(byNameSelectorTemplate, buttonSelector, buttonName)).remove();

      delete me._buttonsEnabledOnlyForOneSelected[buttonName];
      delete me._buttonsEnabledForMultiSelected[buttonName];
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверить наличие кнопки панели инструментов.
    *
    * @method WebAccess.components.wrappers.toolBar.Buttons#isExist
    * @param {string} buttonName Имя кнопки панели инструментов
    * @return {boolean} True, если кнопка существует, иначе False.
    */
    isExist(buttonName) {
      var existingButton = $(format(byNameSelectorTemplate, buttonSelector, buttonName));
      return existingButton.length > 0;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает список кнопок панели действий, которые зависят от указанного прикладного действия.
    * @method WebAccess.components.wrappers.toolBar.Buttons#getButtonsByActionName
	* @param {string} actionName Наименование прикладного действия.
    * @returns {array} Массив кнопок панели действий, которые зависят от указанного прикладного действия.
    */
    getButtonsByActionName(actionName) {
      var buttons = this._buttonsByActionName[actionName.toLowerCase()];
      return buttons ? buttons : [];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает список кнопок панели действий по режиму доступности действия.
    * @method WebAccess.components.wrappers.toolBar.Buttons#getButtonsByEnabledMode
	* @param {ACTION_ENABLED_MODE} enabledMode Режим доступности действия.
    * @returns {array} Массив кнопок панели действий, для которых установлен указанный режим доступности действия.
    */
    getButtonsByEnabledMode(enabledMode) {
      var buttons = this._buttonsByEnabledMode[enabledMode];
      return buttons ? buttons : [];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает список кнопок панели действий, доступных для выбранных вложений.
    * @method WebAccess.components.wrappers.toolBar.Buttons#getButtonsEnabledOnAttachmentSelection
	  * @returns {array} Массив кнопок панели действий, доступность которых изменяется в зависимости от выбора вложений.
    */
    getButtonsEnabledOnAttachmentSelection() {
      return this._buttonsEnabledOnAttachmentSelection;
    },

    /**
    * Получает список кнопок панели действий проводника, доступных только для одной выбранной записи.
    * @method WebAccess.components.wrappers.toolBar.Buttons#getButtonsEnabledOnlyForOneSelected
	  * @returns {array} Массив кнопок панели действий, доступность которых изменяется в зависимости от выбора одной записи.
    */
    getButtonsEnabledOnlyForOneSelected() {
      return this._buttonsEnabledOnlyForOneSelected;
    },

    /**
    * Получает список кнопок панели действий проводника, доступных при множественном выборе.
    * @method WebAccess.components.wrappers.toolBar.Buttons#getButtonsEnabledForMultiSelected
	  * @returns {array} Массив кнопок панели действий, доступность которых изменяется в зависимости от выбора записей.
    */
    getButtonsEnabledForMultiSelected() {
      return this._buttonsEnabledForMultiSelected;
    }
  });

  global.components.wrappers.toolBar.Buttons = Buttons;

})(window.WebAccess);
